export default __webpack_public_path__ + "static/media/user.1af4ff62.png";